<div class="dashboard">
  <p-toast></p-toast>
  <header class="dashboard-header">
    <h1>Transactions</h1>
  </header>
  
  <main class="dashboard-content">
    <section class="daterange-controls">
      <div class="daterange-row" style="display: flex; gap: 1rem; justify-content: center; align-items: flex-start; margin-top: 12px;">

        <div class="field" style="width: 200px;">
          <p-iftaLabel>
            <p-select inputId="tenant-select" [(ngModel)]="selectedTenant"
              [options]="tenants" optionLabel="tenantId" optionValue="tenantId"
              [loading]="loadingTenants" placeholder="Select Tenant"
              [style]="{width: '100%'}" />
            <label for="tenant-select">Select Tenant</label>
          </p-iftaLabel>
          
          <div *ngIf="tenantsFetchFailed && !loadingTenants" 
               style="margin-top: 4px; padding: 6px 8px; background-color: #fef2f2; border: 1px solid #fecaca; border-radius: 4px; display: flex; align-items: center; gap: 6px; font-size: 12px;">
            <i class="pi pi-exclamation-triangle" 
               style="color: #dc2626; font-size: 14px;"></i>
            <span style="color: #dc2626; flex: 1; font-weight: 500;">Failed to load tenants</span>
            <p-button 
              icon="pi pi-refresh" 
              [text]="true" 
              [rounded]="true"
              size="small"
              severity="danger"
              (click)="retryFetchTenants()"
              pTooltip="Retry"
              tooltipPosition="top"
              [style]="{'width': '20px', 'height': '20px', 'min-width': '20px', 'padding': '0', 'margin': '0'}"></p-button>
          </div>
        </div>

        <div class="field" style="width: 200px;">
          <p-iftaLabel>
            <p-select inputId="duration-select" [(ngModel)]="selectedDuration"
              [options]="durationOptions" optionLabel="label" optionValue="value"
              (onChange)="onDurationChange()" [style]="{width: '100%'}" />
            <label for="duration-select">Select Duration</label>
          </p-iftaLabel>
        </div>

        <div class="field">
          <p-iftaLabel>
            <p-datepicker inputId="from-date" [(ngModel)]="fromDate" [showIcon]="true" [placeholder]="'YYYY/MM/DD'"
              [disabled]="isDatePickerDisabled"
              [maxDate]="maxFromDate" dateFormat="yy/mm/dd" (onSelect)="onFromDateChange()"
              [showTime]="true"
              [hourFormat]="'24'"
              [selectOtherMonths]="true"
              [style]="{width: '100%'}"
              [readonlyInput]="true"
              [ngClass]="{'disable-time': selectedDuration !== 'custom'}" />
            <label for="from-date">From Date</label>
          </p-iftaLabel>
        </div>

        <div class="field" style="width: 300px;">
          <p-iftaLabel>
            <p-datepicker inputId="to-date" [(ngModel)]="toDate" [showIcon]="true" [placeholder]="'YYYY/MM/DD'"
              [disabled]="isDatePickerDisabled"
              [maxDate]="maxToDate" dateFormat="yy/mm/dd" (onSelect)="onToDateChange()"
              [showTime]="true"
              [hourFormat]="'24'"
              [selectOtherMonths]="true"
              [style]="{width: '100%'}"
              [readonlyInput]="true"
              [ngClass]="{'disable-time': selectedDuration !== 'custom'}" />
            <label for="to-date">To Date</label>
          </p-iftaLabel>
        </div>

        <div class="field" style="width: 200px; margin-top: 8px;">
          <p-button label="Apply" [severity]="'info'" icon="pi pi-search" (click)="onGetTransactions()" [disabled]="loading"
            [style]="{width: '100%'}" />
        </div>
      </div>
    </section>

    <section class="category-controls">
      <div class="category-label">View</div>
      <p-selectbutton
        [(ngModel)]="selectedCategories"
        [options]="categoryOptions"
        optionLabel="label"
        optionValue="value"
        [multiple]="true"
        [disabled]="loading || loadingMore"
        (onChange)="onCategoryChange()" />
      <p-checkbox
        inputId="multi-select-mode"
        [(ngModel)]="multiSelectMode"
        [binary]="true"
        [disabled]="loading || loadingMore"
        (onChange)="onMultiSelectModeChange()" />
      <label for="multi-select-mode">Select multiple</label>
      <span class="category-hint" *ngIf="selectedCategories.length > 1">
        <i class="pi pi-info-circle"></i> Showing merged results from {{ selectedCategories.length }} categories
      </span>
    </section>

    <section class="transactions-section">
      <p-table
        [value]="transactions" [rowTrackBy]="trackByEpochNano"
        [paginator]="transactions.length > 0"  
        [paginatorStyleClass]="loadingMore ? 'loading-more' : ''" [rows]="25" [rowsPerPageOptions]="[10, 25, 50, 100]"
        dataKey="epochNanoSeconds" 
        [expandedRowKeys]="expandedRows"
        scrollable="true"
        scrollHeight="calc(100vh - 350px)"
        [tableStyle]="{'min-width': '1200px'}"
        showCurrentPageReport="true"
        showGridlines="true"
        sortField="epochNanoSeconds"
        [sortOrder]="-1"
        currentPageReportTemplate="Showing {first} to {last} of {totalRecords} transactions" 
        [globalFilterFields]="globalFilterFields"
        #dt>

        <ng-template pTemplate="caption">
          <div style="display: flex; align-items: center; gap: 2rem; width: 100%;">
            <p-button 
              label="Clear" 
              icon="pi pi-filter-slash" 
               (click)="onClear(dt)" 
              [outlined]="true"
              severity="secondary"
              size="small"
              [style]="{'flex-shrink': '0', 'white-space': 'nowrap'}" />
            <div style="flex: 1; display: flex; align-items: center;">
              <p-inputGroup style="width: 100%;">
                <p-inputGroupAddon>
                  <i class="pi pi-search"></i>
                </p-inputGroupAddon>
                <input pInputText type="text" [(ngModel)]="transactionIdFilter" 
                      placeholder="Search across all fields" 
                      (input)="onGlobalFilterChange($event)" style="width: 100%;" />
              </p-inputGroup>
            </div>
            <p-button 
              label="Export CSV" 
              icon="pi pi-external-link" 
              (click)="exportToCSV()" 
              [disabled]="transactions.length === 0 || loadingMore"
              severity="contrast"
              size="small"
              [style]="{'flex-shrink': '0', 'white-space': 'nowrap'}" />
          </div>
        </ng-template>

        <ng-template #header>
          <tr>
            <th style="width: 3rem"></th>
            <th *ngFor="let col of visibleColumns" [pSortableColumn]="col.sortField || col.field" [class]="col.cssClass">
              <div class="header-flex">
                <span>{{ col.header }}</span>
                <span class="header-icons">
                  <p-sortIcon [field]="col.sortField || col.field"></p-sortIcon>
                  
                  <p-columnFilter *ngIf="col.filterType === 'text'" type="text" [field]="col.field" display="menu" [showAddButton]="false"></p-columnFilter>
                  <p-columnFilter *ngIf="col.filterType === 'numeric'" type="numeric" [field]="col.field" display="menu" [showAddButton]="false"></p-columnFilter>
                  
                  <p-columnFilter *ngIf="col.field === 'isoTimestamp'" type="date" field="timestampDate" display="menu" [matchModeOptions]="timestampDateColumnFilterOptions" [matchMode]="'dateTimeAfter'" [showOperator]="false">
                    <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                      <p-datepicker 
                        [ngModel]="value" 
                        (onSelect)="filter($event)" 
                        [readonlyInput]="true"
                        [dateFormat]="'yy/mm/dd'"
                        [showIcon]="true"
                        [style]="{width: '100%'}"
                        [minDate]="fromDate"
                        [maxDate]="toDate"
                        [showTime]="true"
                      ></p-datepicker>
                    </ng-template>
                  </p-columnFilter>
                  
                  <p-columnFilter *ngIf="col.field === 'messageFrom'" field="messageFrom" display="menu" matchMode="in" [showMatchModes]="false" [showOperator]="false" [showAddButton]="false">
                    <ng-template #filter let-value let-filter="filterCallback">
                      <p-multiselect [(ngModel)]="sourceFilterValue" [options]="sourceOptions" (onChange)="filter($event.value)" placeholder="Select Source" class="w-full" [showToggleAll]="false" [display]="'chip'" optionLabel="label" optionValue="value" [showHeader]="false" [filter]="true" [showClear]="true" [panelStyle]="{ minWidth: '14rem' }"></p-multiselect>
                    </ng-template>
                  </p-columnFilter>
                  
                  <p-columnFilter *ngIf="col.field === 'messageTo'" field="messageTo" display="menu" matchMode="in" [showMatchModes]="false" [showOperator]="false" [showAddButton]="false">
                    <ng-template #filter let-value let-filter="filterCallback">
                      <p-multiselect [(ngModel)]="destinationFilterValue" [options]="destinationOptions" (onChange)="filter($event.value)" placeholder="Select Destination" class="w-full" [showToggleAll]="false" [display]="'chip'" optionLabel="label" optionValue="value" [showHeader]="false" [filter]="true" [showClear]="true" [panelStyle]="{ minWidth: '14rem' }"></p-multiselect>
                    </ng-template>
                  </p-columnFilter>
                  
                  <p-columnFilter *ngIf="col.field === 'hostResponseCodeText'" type="boolean" field="hostResponseIsApproved" display="menu" [showAddButton]="false">
                    <ng-template #filter let-value let-filter="filterCallback">
                      <p-select [(ngModel)]="approvedFilterValue" [options]="approvedOptions" (onChange)="filter($event.value)"placeholder="Select Status" class="w-full"></p-select>
                    </ng-template>
                  </p-columnFilter>
                </span>
              </div>
            </th>
          </tr>
        </ng-template>

        <ng-template #body let-transaction let-expanded="expanded">
          <tr>
            <td>
              <p-button class="expand-icon" type="button" pRipple [pRowToggler]="transaction" [text]="true"
                        severity="secondary" [rounded]="true"
                        [icon]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'" />
            </td>
            <td *ngFor="let col of visibleColumns" [class]="col.cssClass">
              {{ getFieldValue(transaction, col) }}
            </td>
          </tr>
        </ng-template>

        <ng-template #expandedrow let-transaction>
          <tr>
            <td></td>
            <td [attr.colspan]="visibleColumns.length + 1" class="expanded-row-cell">
              <div>
                <h5>Message Details</h5>
                <div class="message-content">
                  <pre>{{ formatJson(transaction.message) }}</pre>
                </div>
              </div>
            </td>
          </tr>
        </ng-template>

        <ng-template pTemplate="paginatorleft">
          <p-button
            *ngIf="loadingMore"
            label="Cancel"
            icon="pi pi-times"
            size="small"
            variant="outlined"
            severity="danger"
            (click)="cancelLoad()" />
        </ng-template>

        <ng-template pTemplate="emptymessage">
          <tr>
            <td [attr.colspan]="visibleColumns.length + 1" style="position: relative; height: 50vh;">
              <div style="width: 400px; margin-left: 37vw;">
                <div *ngIf="loading || loadingMore" style="display: flex; flex-direction: column; align-items: center;">
                  <span class="pi pi-spin pi-spinner" style="font-size:2rem; margin-bottom:1rem;"></span>
                  <p>Searching transactions, please wait...</p>
                </div>

                <div *ngIf="!loading && !loadingMore" style="display: flex; flex-direction: column; align-items: center; color: #6c757d;">
                  <i class="pi pi-inbox" style="font-size: 4rem; margin-bottom: 1rem; opacity: 0.6;"></i>
                  <p style="margin: 0; font-size: 1.1rem;">No transactions found</p>
                  <p style="margin: 0.5rem 0 0 0; font-size: 0.9rem; opacity: 0.8;">Please apply a date range to begin</p>
                </div>
              </div>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </section>
  </main>
</div>